import React, {PureComponent} from 'react';
import {connect, Field, FieldArray, ErrorMessage} from 'formik';
import {FormattedMessage, injectIntl} from 'react-intl';
import get from 'lodash/get';
import messages from '../../../../res/translations/messages';
import ExpressionType from './ExpressionType';
import MinusButton from './MinusButton';
import FilterButton from './FilterButton';
import Error from '../../Error';
import TooltipContainer from '../../TooltipContainer';

// TODO remove disable lint
/* eslint-disable react/jsx-no-bind */
class ScriptGeneratorClassifier2ChoicesForm extends PureComponent {
    constructor(props) {
        super(props);
        this.addFilter = this.addFilter.bind(this);
        this.removeFilter = this.removeFilter.bind(this);
    }

    componentDidMount() {
        this.props.formik.registerField(this.props.id, this);
    }

    componentWillUnmount() {
        this.props.formik.unregisterField(this.props.id);
    }

    componentDidUpdate(prevProps) {
        const {formik, id} = this.props;
        if (id !== prevProps.id) {
            formik.unregisterField(prevProps.id);
            formik.registerField(this.props.id, this);
        }
    }

    async addFilter() {
        const {formik, id} = this.props;
        let scripts = get(formik.values, id);
        if (!scripts) {
            scripts = [];
        }
        await formik.setFieldValue(id, scripts.concat({expression: [], id: ''}));
        formik.validateForm();
    }

    async removeFilter(index) {
        const {formik, id} = this.props;
        const scripts = get(formik.values, id);
        const newScripts = scripts.slice();
        newScripts.splice(index, 1);
        await formik.setFieldValue(id, newScripts);
        formik.validateForm();
    }

    render() {
        const {/* intl, */ formik, id, previousPages, items, extraFields, parameters} = this.props;
        return (
            <>
                {get(formik.values, id) && get(formik.values, id).map((script, index) => (
                    <div className="script" key={index}>
                        <div className="row pr-2 align-items-center">
                            <div className="col-9">
                                <FieldArray name={`${id}.${index}.expression`}
                                    render={(arrayHelpers) => (
                                        <div key={index}>
                                            <Field name={`${id}.${index}.expression`}
                                                previousPages={previousPages}
                                                items={items}
                                                extraFields={extraFields}
                                                parameters={parameters}
                                                component={ExpressionType}
                                                push={arrayHelpers.push}
                                                remove={arrayHelpers.remove}
                                            />
                                        </div>
                                    )}
                                />

                            </div>
                            <div className="col-3">
                                <div className="d-flex">
                                    <TooltipContainer tooltip={messages.jumps.tooltip.remove}>
                                        <MinusButton className="ml-2" remove={this.removeFilter} index={index} />
                                    </TooltipContainer>
                                </div>
                                <ErrorMessage name={`${id}.${index}.id`}>
                                    {(message) => <Error reason={message.key} reasonParams={message.params} />}
                                </ErrorMessage>
                            </div>
                        </div>
                    </div>
                ))}
                <FilterButton onClick={this.addFilter}>
                    <FormattedMessage {...messages.conditions.button.new} />
                </FilterButton>
            </>
        );
    }
}

export default connect(injectIntl(ScriptGeneratorClassifier2ChoicesForm));
